import { NotificationType } from '../../../../../services/exports/Constants';

export default {
  title: 'U heeft {{length}} meldingen',
  notifications: {
    titles: {
      [NotificationType.PaymentGatewayVerificationPending]: 'Betalingsinfo in beoordeling',
      [NotificationType.PaymentGatewayVerificationSuccessful]: 'Betalingsinfo goedgekeurd',
      [NotificationType.PaymentGatewayVerificationFailed]: 'Betalingsinfo fout',
    },
    descriptions: {
      [NotificationType.PaymentGatewayVerificationPending]:
        'Uw betalingsinformatie wordt beoordeeld door Stripe. Dit kan tot 48 uur duren.',
      [NotificationType.PaymentGatewayVerificationSuccessful]:
        'Uw betalingsinformatie is succesvol geverifieerd. U kunt nu betalingen ontvangen.',
      [NotificationType.PaymentGatewayVerificationFailed]:
        'Er lijkt een fout te zijn met uw informatie. Klik hier om uw informatie bij te werken.',
    },
  },
};
